import utils from 'utils';
class addUserCtrl {
  constructor(
    $scope,
    logger,
    httpRequest,
    $state,
    formvalidateApi,
    $rootScope
  ) {
    //机构树的check配置信息
    $scope.config = {
      check: {
        enable: true, //显示不显示复选框
        chkboxType: { Y: '', N: '' },
        chkStyle: 'radio',
        radioType: 'all',
      },
    };
    $scope.userType = $rootScope.userInfo.user.userType;
    // 有缓存参数，从缓存中取orgOwnership
    const orgOwnerShip = JSON.parse(localStorage.user_info).user.orgOwnership;
    if (JSON.parse(localStorage.user_info).org) {
      $scope.parentOrgId = JSON.parse(localStorage.user_info).org.parentOrgId;
    }
    $scope.userTypeOrgId = $scope.userType ? orgOwnerShip : 0;
    $scope.inputType = 'text';

    function reset() {
      $scope.allUkeyIdList = $scope.allUkeyIdList || [];
      let orgOwnership =
        ($scope.adduserInfo && $scope.adduserInfo.orgOwnership) || '';
      let departmentId =
        ($scope.adduserInfo && $scope.adduserInfo.departmentId) || '';
      $scope.adduserInfo = {
        usedPasswordDefault: true,
        roleIdList: [],
        ukeyIdList: [],
        status: 1,
        orgOwnership: orgOwnership,
        userMobile: '',
        userName: '',
        passwordText: '',
        passwordTextConfirm: '',
        realName: '',
        userEmail: '',
        departmentId: departmentId,
      };
      if ($state.params.orgId && !orgOwnership) {
        $scope.adduserInfo.orgOwnership = $state.params.orgId;
      }
      $scope.s3item = [];
      $scope.allUkeyIdList.forEach((ukey) => {
        ukey.selected = false;
      });
    }
    reset();

    //获取开票点
    const queryOrgInfo = function queryOrgInfo() {
      let orgId = $scope.adduserInfo.orgOwnership;
      if ($scope.userType == 0 && !orgId) return;
      if (!orgId) {
        orgId = $scope.userInfo.org.orgId;
      }
      httpRequest.get_qryAssignUkeyList(orgId).then((res) => {
        $scope.allUkeyIdList = res.data.value;
        $scope.allUkeyIdList.forEach((ukey) => {
          ukey.selected = false;
        });
      });
    };
    queryOrgInfo();

    //获取部门
    const getDepartmentList = function getDepartmentList() {
      if (!$scope.adduserInfo.orgOwnership && $scope.userType == 0) return;
      let params = {
        pageNum: 0,
        pageSize: 10000,
        param: {},
      };
      if ($scope.adduserInfo.orgOwnership && $scope.userType == 0) {
        params.param.orgId = $scope.adduserInfo.orgOwnership;
      }
      httpRequest.post_qryDepartmentList(params).then((res) => {
        $scope.departmentList = res.data.value.list;
        $scope.adduserInfo.departmentId = $scope.departmentList[0].departmentId;
      });
    };
    getDepartmentList();

    // 是否使用预置密码
    $scope.usedPasswordDefaultFlag = function usedPasswordDefaultFlag(val) {
      $scope.adduserInfo.usedPasswordDefault = val;
    };

    function makeUser(userInfo) {
      userInfo.roleIdList = [];
      userInfo.ukeyIdList = [];
      $scope.s3item.forEach((item) => {
        userInfo.roleIdList.push(item.id);
      });
      if (userInfo.usedPasswordDefault) {
        userInfo.passwordText = '';
      }
      if ($scope.allUkeyIdList.length) {
        for (let i = 0; i < $scope.allUkeyIdList.length; i++) {
          if ($scope.allUkeyIdList[i].selected) {
            userInfo.ukeyIdList.push($scope.allUkeyIdList[i].ukeyId);
          }
        }
      }
    }

    function validateUser(userInfo) {
      const orgId = userInfo.orgOwnership;
      if (!orgId) {
        logger.logError('请选所在择机构');
        return false;
      }
      if (
        !/^[0-9]{11}$/.test(userInfo.userName) &&
        $scope.current.usePhone == 1 &&
        $scope.current.deployType == 2
      ) {
        logger.logTips('登陆账号必须输入11位数字格式', 'warn');
        return false;
      }
      const mark = formvalidateApi.run();
      if (!mark) {
        return false;
      }
      const isArr = Boolean(userInfo.roleIdList.length);
      if (!isArr) {
        logger.logError('请选择角色');
        userInfo.usedPasswordDefault = Boolean(userInfo.usedPasswordDefault);
        return false;
      }
      return true;
    }
    $scope.addUser = function addUser(isContinue) {
      $scope.adduserInfo.usedPasswordDefault = Number(
        $scope.adduserInfo.usedPasswordDefault
      );
      makeUser($scope.adduserInfo);
      if (validateUser($scope.adduserInfo)) {
        if (!$scope.adduserInfo.orgOwnership && $scope.userType != 0) {
          $scope.adduserInfo.orgOwnership = $scope.userInfo.org.orgId;
        }
        httpRequest.add_userInfo($scope.adduserInfo, '添加信息成功').then(
          () => {
            if (isContinue) {
              reset();
            } else {
              $scope.cancle();
            }
          },
          () => {
            $scope.adduserInfo.usedPasswordDefault = Boolean(
              $scope.adduserInfo.usedPasswordDefault
            );
          }
        );
      } else {
        $scope.adduserInfo.usedPasswordDefault = Boolean(
          $scope.adduserInfo.usedPasswordDefault
        );
      }
    };

    $scope.cancle = function cancle() {
      let search = '';
      if ($state.params.orgId) {
        search = encodeURI(
          JSON.stringify({
            orgIdList: [$state.params.orgId],
          })
        );
        $state.go('system.permission.user.list', {
          search,
        });
      } else {
        $state.go('system.permission.user.list');
      }
    };

    //获取角色
    const getRoleList = function getRoleList() {
      $scope.s3item = [];
      $scope.taxpayerOptions3 = {
        data: [],
      };
      let orgId = $scope.adduserInfo.orgOwnership;
      if ($scope.userType == 0 && !orgId) return;
      if (!orgId) {
        orgId = $scope.userInfo.org.orgId;
      }
      httpRequest.get_userOrgRole(orgId).then((res) => {
        $scope.taxpayerOptions3.placeholder = '请选择';
        let list =res.data.value
        if($scope.userInfo.user.userType!==0){
          list = list.filter(ele=>{
            return ele.specialTag==='0'
          })
        }
        const ret = toSelect2data(list, 'roleId', 'roleName');
        $scope.taxpayerOptions3.data = ret;
        
      });
    };
    getRoleList();

    function toSelect2data(list, idfield, textfield) {
      const result = [];
      for (const a in list) {
        const tempdata = {
          id: '',
          text: '',
        };
        $.extend(tempdata, list[a]);
        tempdata.id = list[a][idfield];
        tempdata.text = list[a][textfield];
        result.push(tempdata);
      }
      return result;
    }

    // 电话校验规则
    $scope.validateRules = {
      userMobile: [
        {
          erromsg: '手机号码格式错误',
          condition(value) {
            // 规则
            const regex = /^[0-9]{11}$/;

            const result = (value == '') | (value == null) | regex.test(value);
            // true 标示显示 errmsg  false 标示验证通过
            return !result;
          },
        },
      ],
      realName: [
        {
          erromsg: '限制20个字符以内',
          condition(value) {
            let result = true;
            if (value.length > 20) result = false;
            // true 标示显示 errmsg  false 标示验证通过
            return !result;
          },
        },
      ],
      userEmail: [
        {
          erromsg: '邮箱格式错误',
          condition(value) {
            // 规则
            const regex = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
            let result = (value == '') | (value == null) | regex.test(value);
            if (value.length > 50) result = false;
            // true 标示显示 errmsg  false 标示验证通过
            return !result;
          },
        },
      ],
      passwordTextConfirm: [
        {
          erromsg: '必填项',
          condition(value) {
            return !$scope.adduserInfo.usedPasswordDefault && !value;
          },
        },
        {
          erromsg: '初始密码与确认密码不一致',
          condition(value) {
            return (
              !$scope.adduserInfo.usedPasswordDefault &&
              value !== $scope.adduserInfo.passwordText
            );
          },
        },
      ],
      passwordText: [
        {
          erromsg: '必填项',
          condition(value) {
            return !$scope.adduserInfo.usedPasswordDefault && !value;
          },
        },
      ],
    };
    utils.loading('正在加载···');
    //获取机构列表
    httpRequest.get_organization($scope.userTypeOrgId).then((res) => {
      $scope.orgList = res.data.value;
      utils.loaded();
      $scope.nodeCtrl($scope.orgList);
      for (var i = 0; i < $scope.orgList.length; i++) {
        if ($scope.orgList[i].orgId == $state.params.orgId) {
          $scope.queryOrgConfig.defaultSelect = [$scope.orgList[i]];
          $scope.queryOrgConfig.parentId = $scope.orgList[i].parentOrgId;
          $scope.selectedOrgList = [$scope.orgList[i]];
          $scope.adduserInfo.orgOwnership = $scope.orgList[i].orgId;
          break;
        }
      }
    });
    // 节点的配置
    $scope.nodeCtrl = function (orgList) {
      angular.forEach(orgList, function (item) {
        item.open = true;
        item.checked = false;
      });
    };
    $scope.queryOrgConfig = {
      queryName: 'orgName',
      queryKey: 'orgId',
      queryType: 'radioTree',
      parentIdName: 'parentOrgId',
      multiple: false,
      // 修改
      parentId: $scope.userType ? $scope.parentOrgId : -1,
      defaultSelect: [],
    };
    // 机构变化
    $scope.orgSelectChange = function (v) {
      $scope.queryOrgConfig.defaultSelect = v;
      $scope.selectedOrgList = v;
      $scope.adduserInfo.orgOwnership = v[0].orgId;
      $scope.adduserInfo.departmentId = '';
      $scope.departmentList = [];
      getDepartmentList();
      $scope.adduserInfo.roleIdList = [];
      getRoleList();
      $scope.adduserInfo.ukeyIdList = [];
      queryOrgInfo();
    };
    $scope.roleChange = (i) => {
      $scope.isManager = false;
      $scope.taxpayerOptions3.data.forEach((item) => {
        i.split(',').forEach((id) => {
          if (item.id == id && item.roleType == 2) $scope.isManager = true;
        });
      });
    };
    $scope.$watch('s3item', () => {
      if ($scope.s3item && !$scope.s3item.length) {
        for (const a in $scope.allUkeyIdList) {
          $scope.allUkeyIdList[a].selected = false;
        }
      }
    });
    $scope.$watch('isManager', () => {
      if ($scope.isManager) {
        for (const a in $scope.allUkeyIdList) {
          $scope.allUkeyIdList[a].selected = true;
        }
      }
    });
    $scope.current = {
      deployType: localStorage.deployType,
      usePhone: '1',
    };
    // $scope.usePhone = '1'
    // $scope.$watch('current.usePhone', () => {
    //     if ($scope.current.usePhone == 1 && $scope.current.deployType == 2) {
    //         $scope.adduserInfo.usedPasswordDefault = true
    //         if (!/^[0-9]{11}$/.test($scope.adduserInfo.userName)) {
    //             $scope.adduserInfo.userName = ''
    //             logger.logTips('请输入手机号作为登陆账号', 'warn')
    //         }
    //         $scope.adduserInfo.userMobile = $scope.adduserInfo.userName
    //     } else {
    //         $scope.adduserInfo.usedPasswordDefault = false
    //     }
    // })
    $scope.usePhoneChange = function () {
      if ($scope.current.usePhone == 0 && $scope.current.deployType == 2) {
        $scope.adduserInfo.usedPasswordDefault = true;
        if (!/^[0-9]{11}$/.test($scope.adduserInfo.userName)) {
          // $scope.adduserInfo.userName = ''
          logger.logTips('登陆账号必须输入11位数字格式', 'warn');
        }
        $scope.adduserInfo.userMobile = $scope.adduserInfo.userName;
      } else {
        $scope.adduserInfo.usedPasswordDefault = false;
      }
    };
    $scope.checkUserName = function () {
      if (!$scope.adduserInfo.userName) return;
      if ($scope.current.usePhone == 1) {
        if (!/^[0-9]{11}$/.test($scope.adduserInfo.userName)) {
          // $scope.adduserInfo.userName = ''
          logger.logTips('登陆账号必须输入11位数字格式', 'warn');
        }
        $scope.adduserInfo.userMobile = $scope.adduserInfo.userName;
      }
    };
  }
}

addUserCtrl.$inject = [
  '$scope',
  'logger',
  'httpRequest',
  '$state',
  'formvalidateApi',
  '$rootScope',
];
export default addUserCtrl;



// WEBPACK FOOTER //
// ./src/app/system/permission/user/add_userCtrl.js